(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorneu-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',e=>{document.querySelectorAll('.vn-header details[open]').forEach(d=>{if(!d.contains(e.target)||e.target.closest('a'))d.open=false;});});
document.addEventListener('keydown',e=>{if(e.key==='Escape'){const d=e.target.closest('.vn-header details[open]');if(d){d.open=false;d.querySelector('summary').focus();}}});
document.addEventListener('change',e=>{if(e.target.matches('[data-vn-localize]'))e.target.form.requestSubmit();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorneu-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',event=>{
 const select=event.target.closest('[data-vorneu-variant]'); if(!select)return;
 const option=select.options[select.selectedIndex],button=select.form.querySelector('[name="add"]'),price=document.getElementById(select.dataset.priceTarget);
 if(price){
  price.querySelector("[data-vorneu-current-price]").textContent=option.dataset.price;
  const compare=price.querySelector("[data-vorneu-compare-price]");
  compare.textContent=option.dataset.compare||"";
  compare.hidden=!option.dataset.compare;
 }
 button.disabled=option.dataset.available!=='true';
 button.textContent=button.disabled?button.dataset.soldLabel:button.dataset.addLabel;
 const url=new URL(window.location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url);
});

  } catch(e) { console.error(e); }
})();
})();
